import { useCallback, useMemo } from 'react';

import { useSearch } from '~extension/icon-library/context/Search';
import { Tag } from '../Tag';

export const Categories = () => {
  const { categoriesWithIcons: categories, activeCategories, toggleCategory } = useSearch();
  const hasSearchCategories = useMemo(() => categories && categories.length > 0, [categories]);

  const handleCategoryClick = useCallback(
    (cat: string) => {
      toggleCategory(cat);
    },
    [toggleCategory],
  );

  if (hasSearchCategories) {
    return (
      <div className={`flex flex-wrap mt-2`}>
        {categories.map(cat => (
          <div className={`m-1`} key={cat}>
            <Tag onClick={handleCategoryClick} label={cat} active={activeCategories.includes(cat)} />
          </div>
        ))}
      </div>
    );
  }

  return null;
};
